
import $ from 'jquery';
import App from '../app';
import HistoryAPI from '../history';
import * as D from '../data-utils';
  
var lunchlist = {};
let history;


function init(context) {
  const { feature } = context.imdSettings;
  const langs = D.langs();
  const lang = D.lang();
  const translations = App.getTranslations(langs);
  var lunchData = D.getLunchMenus();
  const today = new Date().getDay() -1;
  const defaultLang = D.defaultLang();
  let showNoContentDialog = defaultLang != lang;

  lunchData.map(lunch => {
    let store = D.getStoreById(lunch.store.id);
    if(store) {
      lunch.store.logoURL = store.logoURL;
      lunch.lunchToday = lunch.dailyLunchMenus[today >= 0? today: 6];
      lunch.showMoreTranslation = translations[lang]['common.showMore'];
    }
  });

  lunchlist = D.getData('currentLunchlist', 'all');

  if($.isEmptyObject(lunchlist)){
    lunchlist = {
      lunchlist: lunchData,
      iconsvg: context.resources.get('ic_lunch_menu'),
      icontitle: translations[lang]['store.lunchToday'],
      lunchsortby: 'menu',
      lastMenuViewPosition: 0,
      lastRestaurantsViewPosition: 0,
      translations: translations,
      currentLang: lang,
      feature,
      showNoContentDialog
    };
  }

  history = new HistoryAPI('#lunchmenu', {
    lunchlist,
    today,
    translations
  });
  return lunchlist;
}

function getLunchList(){
  return lunchlist;
}

function goBack(){
  window.history.back();
}

function setLunchSortBy(lunchsortby){
  lunchlist.lunchsortby = lunchsortby;
}

function saveState(){
  history.saveState(lunchlist);
}

function updateLastMenuViewPosition (position, currentLang) {
  lunchlist.lastMenuViewPosition = position;
  App.saveLocally(lunchlist, 'currentLunchlist', currentLang);
}

function updateLastRestaurantsViewPosition (position, currentLang) {
  lunchlist.lastRestaurantsViewPosition = position;
  App.saveLocally(lunchlist, 'currentLunchlist', currentLang);
}

function resetLastPosition() {
  lunchlist.lastMenuViewPosition = 0;
  lunchlist.lastRestaurantsViewPosition = 0;
}

export default {
  init,
  getLunchList,
  goBack,
  setLunchSortBy,
  saveState,
  updateLastMenuViewPosition,
  updateLastRestaurantsViewPosition,
  resetLastPosition
};
